import * as React from 'react'
import { QueryResult } from 'react-apollo'

import { regionSearchPath } from 'main/routes'
import { Link, Strong } from 'main/ui'
import { useTranslation } from 'react-i18next'
import { LOCIZE_NAMESPACE } from '../../../../common'
import { i18nKeyPrefix } from '../../i18n'
import { RelatedPrograms as RelatedProgramsData, RelatedProgramsVariables } from '../gql'
import Callout from './Callout'
import { CalloutContainer, TitleContainer } from './Content.styles'

const PRE = `${i18nKeyPrefix}-RELATED-PROGRAMS`

interface IProps {
  result: QueryResult<RelatedProgramsData, RelatedProgramsVariables>
}

export default function Content(props: IProps) {
  const {
    result: { error, data },
  } = props

  const { t } = useTranslation(LOCIZE_NAMESPACE)

  if (error || !data || !data.schoolListings) return null

  const {
    schoolListings: { listings, location },
  } = data
  if (!location || !location.city || !location.state) return null
  if (!listings.length) return null

  const region = { state: location.state, city: location.city }
  const regionText = `${location.city}, ${location.state}`

  return (
    <div>
      <TitleContainer>
        <Strong>{t(`${PRE}-TEXT`)}</Strong>&nbsp;
        <Link to={regionSearchPath(region)}>{regionText}</Link>
      </TitleContainer>

      <div>
        {listings.map((listing, i) => (
          <CalloutContainer key={i}>
            <Callout listing={listing} />
          </CalloutContainer>
        ))}
      </div>
    </div>
  )
}
